/**
 * @description: 开房套餐盈利汇总报表
 * @author: lyr
*/
<template>
    <div class="goodspackage-total-report">
        <div class="red-tip">注：当天营业数据就只能单个营业日，历史数据支持一个月内的数据查询</div>
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开房套餐类型">
                    <el-select v-model="list_form.package_type" clearable placeholder="请选择开房套餐类型">
                        <el-option v-for="item in package_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开房套餐名称">
                    <el-input v-model="list_form.title" clearable placeholder="请输入开房套餐名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <div class="total-row">
                <div class="item">折后总额：{{actual_total}}</div>
                <div class="item">成本总额：{{buying_price_total}}</div>
                <div class="item">利润总额：{{profit_price_total}}</div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}"
                :data="list_table">
                <el-table-column prop="package_type_name" label="开房套餐类型"></el-table-column>
                <el-table-column prop="title" label="开房套餐名称" width="150"></el-table-column>
                <el-table-column prop="price" label="单价"></el-table-column>
                <el-table-column prop="quantity" label="销售总量"></el-table-column>
                <el-table-column prop="actual" label="折后单价"></el-table-column>
                <el-table-column prop="actual_total" label="折后总额"></el-table-column>
                <el-table-column prop="buying_price" label="成本单价"></el-table-column>
                <el-table-column prop="buying_price_total" label="成本总额"></el-table-column>
                <el-table-column prop="profit_price_total" label="利润总额"></el-table-column>
                <el-table-column prop="profit_margin" label="利润率"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'goodspackage-detail-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                package_type_list: [{
                    id: '0',
                    name: '全部'
                }, {
                    id: '1',
                    name: '时间套餐'
                }, {
                    id: '2',
                    name: '酒水套餐'
                }, {
                    id: '3',
                    name: '最低消费套餐'
                }, {
                    id: '4',
                    name: '团购套餐'
                }],
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    package_type: '0',
                    title: '',
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                actual_total: 0, // 折后总额
                buying_price_total: 0, // 成本总额
                profit_price_total: 0, // 利润总额
            }
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getList(1);
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Report/getPackageSalesSumList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.list_form.start_time,
                            "end_date": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
                            "package_type": _this.list_form.package_type,
                            "title": _this.list_form.title,
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total)
                            _this.actual_total = res.data.response.result.actual_total
                            _this.buying_price_total = res.data.response.result.buying_price_total
                            _this.profit_price_total = res.data.response.result.profit_price_total
						}
						_this.list_table = res.data.response.result.rows;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },
            
            listExport: function() {
                window.location.href = Vue.ctUrl + "Report/packageSalesSumExport" +
                    "?start_date=" + this.list_form.start_time +
                    "&end_date=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&package_type=" + this.list_form.package_type +
                    "&title=" + this.list_form.title;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .red-tip {
        color: red;
        margin-bottom: 10px;
    }

    .total-row {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .item {
            margin-right: 50px;
        }
    }
</style>